module.exports = __webpack_public_path__ + "img/signal_cellular_1_bar-red.2471d01a.svg";